"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
function CountdownTimer(props) {
  var endTimeMs = props.endTimeMs,
    renderText = props.renderText,
    _a = props.style,
    style = _a === void 0 ? {} : _a;
  var _b = react_1.default.useState(endTimeMs > new Date().getTime() ? endTimeMs - new Date().getTime() : 0),
    remaining = _b[0],
    setRemaining = _b[1];
  react_1.default.useEffect(function () {
    var now = new Date().getTime();
    var timer;
    if (now < endTimeMs) {
      timer = setTimeout(function () {
        setRemaining(endTimeMs - now);
      });
    } else {
      setRemaining(0);
    }
    return function () {
      clearTimeout(timer);
    };
  }, [remaining, endTimeMs]);
  if (remaining === 0) {
    return props.children;
  }
  return react_1.default.createElement("div", {
    style: style
  }, typeof renderText === 'function' ? renderText(Math.ceil(remaining / 1000)) : "" + Math.ceil(remaining / 1000));
}
exports.default = CountdownTimer;